/** EN uses Swedish values until translated. */
export const componentsTranslationsEn = {
    pressReleasesFilter: {
        contentType: {
            all: 'Show all',
            analyzeAndIr: 'Analysis & IR',
            pressReleases: 'Press releases',
            reports: 'Reports',
            relatedTransactions: 'Transactions',
        },
        labels: {
            content: 'Content',
            endDate: 'Time period end',
            pointInTime: 'Time',
            freeTextSearch: 'Text search',
            twoSelected: '2 selected',
        },
    },
    underwritersTable: {
        subscriptionWithoutRights: 'SC without rights',
        totalInCurrency: 'Total {{currency}}',
        totalPercent: 'Total in %',
        compensationLevel: 'Fee level',
        amountDisclaimer:
            'Complete information regarding amount per investor has not been communicated by the company.',
    },
    dropdownSelect: {
        oneSelected: '1 selected',
        selectedCount: '{{count}} selected',
    },
    issueWarrantSummary: {
        summary: 'Summary',
        secured: 'Secured:',
        outcome: 'Outcome:',
        open: 'Open {{type}}',
    },
    autocomplete: {
        noResults: 'No results',
        groups: {
            issues: 'Issues',
            warrants: 'Warrants',
            companies: 'Companies',
            investors: 'Investors',
            convertibles: 'Convertibles',
            searchHistory: 'Recent searches',
        },
    },
    customDataGridToolbar: {
        customizeColumns: 'Customize columns',
    },
    sourceTypes: {
        cancellation: 'Cancelled',
        update: 'Update',
        stabilisation: 'Stabilisation',
        newCommitments: 'New commitments',
        outcome: 'Outcome',
        publication: 'Publication',
        publicationWarrant: 'Origin',
        terms: 'Terms',
        informationDocument: 'Information document',
        prospectus: 'Prospectus',
        memorandum: 'Memorandum',
        supplement: 'Supplement',
        conversion: 'Conversion',
        offset: 'Offset',
        repayment: 'Repayment',
    },
}
